<template>
  <el-table stripe v-loading="loading" ref="multipleTable" :data="tableData" tooltip-effect="dark" style="width: 100%"
    :header-cell-style="headCellStyle" :height="220">
    <el-table-column prop="mark" :label="$t('integration.sign')" width="150">
      <template #default="{ row }">
        <i style="line-height: 30px; margin-right: 5px" :class="storeFn(row, 'isStore', 'icon')"
          :title="storeFn(row, 'isStore', 'text')"></i>
        <i :style="{
          'line-height': '30px',
          color: row.isEx === 1 ? 'red' : '#00f583',
        }" :class="exFn(row, 'isEx', 'icon')" :title="exFn(row, 'isEx', 'text')"></i>
      </template>
    </el-table-column>
    <el-table-column prop="collectTime" :label="$t('integration.acquisition_time')" show-overflow-tooltip>
      <template #default="{ row }">
        <span style="line-height: 30px">{{
            $timetransition(row['collectTime'])
        }}</span>
      </template>
    </el-table-column>
    <el-table-column prop="name" :label="$t('integration.record_time')" show-overflow-tooltip>
      <template #default="{ row }">
        <span style="line-height: 30px">{{
            $timetransition(row['createTime'])
        }}</span>
      </template>
    </el-table-column>
    <el-table-column prop="val" :label="$t('integration.detection_value')" show-overflow-tooltip>
      <template #default="{ row }">
        <!-- 是门磁时显示‘开启/关闭' -->
        <span v-if="unitObj.key !== 'magnetism'" :class="classFn(row)">{{ unitFn(row['val'], 'no') }}</span>
        <span v-else>{{ magnetismValTypeConvert(row['val']) }}</span>
      </template>
    </el-table-column>
    <el-table-column prop="name" :label="$t('integration.monitoring_interval')" show-overflow-tooltip>
      <template #default="{ row }">
        <span>{{ unitFn(row, 'area') }}</span>
      </template>
    </el-table-column>
  </el-table>
</template>

<script>
import { magnetismValTypeConvert }  from '@/utils/convert'
import { TempUtils } from '@/utils/TempUtil.js';
export default {
  props: ['loading', 'tableData', 'unitObj'],
  data () {
    return {
      storeArray: [
        {
          id: 1,
          text: $t('integration.real_time_data_collection'),
          icon: 'iconfont icon-shishijiankong'
        },
        {
          id: 2,
          text: $t('integration.store_collected_data'),
          icon: 'iconfont icon-yuncunchu'
        }
      ],
      abArray: [
        {
          id: 1,
          text: $t('integration.abnormal'),
          icon: 'el-icon-warning'
        },
        {
          id: 2,
          text: $t('integration.normal'),
          icon: 'el-icon-success'
        }
      ],
      magnetismValTypeConvert
    }
  },
  methods: {
    storeFn (row, key, str) {
      let param = ''
      if (row[key] === 0) {
        param = this.storeArray[0][str]
      } else {
        param = this.storeArray[1][str]
      }
      return param
    },
    exFn (row, key, str) {
      let param = ''
      if (row[key] === 1) {
        param = this.abArray[0][str]
      } else {
        param = this.abArray[1][str]
      }
      return param
    },
    unitFn (val, str) {
      if (str === 'no') {
        return `${TempUtils.convertToCelsius(val,this.unitObj.unit)}${this.unitObj.unit}`

      } else {
        if (!val.min && val.min !== 0 && !val.max && val.max !== 0) return ' '
        return `${val.min || val.min === 0 ? TempUtils.convertToCelsius(val.min,this.unitObj.unit) : ' '}${this.unitObj.unit} ~ ${val.max || val.max === 0 ? TempUtils.convertToCelsius(val.max ,this.unitObj.unit): ' '}${this.unitObj.unit
          }`
      }

      console.log('unitObj===', this.unitObj)
    },
    classFn (row) {
      let className = ''
      if (row.val > row.max) {
        className = 'higher-range'
      } else if (row.val < row.min) {
        className = 'lower-range'
      }
      return className
    }
  }
}
</script>
